import React from 'react';
import { Modal, Spin } from 'antd';
import { WifiOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { styles, createModalTitle } from '../ReconnectionModal.styles';

const SoftReconnectionModal = ({ visible }) => {
  const { t } = useTranslation('modal');

  return (
    <Modal
      title={createModalTitle(t('reconnection.lost_title'))}
      open={visible}
      closable={false}
      footer={null}
      centered
    >
      <div style={styles.modalContent}>
        <div style={styles.iconContainer}>
          <WifiOff
            size={48}
            style={{ color: '#666' }}
          />
        </div>
        <p style={styles.description}>{t('reconnection.restoring_description')}</p>
        <div style={styles.spinnerContainer}>
          <Spin size="small" />
          <span style={styles.spinnerText}>{t('reconnection.reconnecting')}</span>
        </div>
      </div>
    </Modal>
  );
};

export default SoftReconnectionModal;
